export enum Ruleset {
  americanLeague = 'americanLeague',
  nationalLeague = 'nationalLeague',
  scrimmage = 'scrimmage',
  battingPractice = 'battingPractice',
}
